import React, { useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import _, { cloneDeep } from 'lodash';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import { NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';

import { commRefLookup, commRefChangeSort, commRefFetchPage, commRefPageUpdate } from '../../redux/commRefReducer';

import CommRefFilter from './CommRefFilter';
import Pagination from '../Pagination';
import CommRefList from './CommRefList';

const useStyles = makeStyles({
    title: {
        "& a.nav-link": {
            padding: "0px",
        },

        "& h1": {
            paddingBottom: "15px",
            fontSize: "26px",
            lineHeight: "26px",
            fontWeight: "bold",
        },

    },
});

export default function CommRef() {
    const classes = useStyles();

    const history = useHistory();

    const dispatch = useDispatch();

    const newCommRef = () => {
        history.push("/commRefDetail/0");
    }

    const { isLoading, filter, entities, workingEntityId, errors } = useSelector(state => {
        return state.commRef;
    });

    const { jWTClaimModel: { Creds } } = useSelector(state => {
        return state.auth;
    });

    useEffect(() => {
        if (!Creds.includes("COMMISSION")) history.replace("/");

        dispatch(commRefLookup());
    }, []);

    const sorts = JSON.parse(filter.sort);

    return (
        <>
            <Breadcrumbs className={classes.title}>
                <NavLink className="nav-link" tag={Link} to="/setting">
                    <Typography variant="h1" className={classes.title}>10. 設定</Typography>
                </NavLink>
                <Typography variant="h1" className={classes.title}>參考地址</Typography>
            </Breadcrumbs>
            <Grid container justifyContent="space-between" className="mb-2">
                <Grid item>
                    <Button variant="contained" size="small" onClick={newCommRef}>新增參考地址</Button>
                </Grid>
            </Grid>

            <CommRefFilter filter={filter} />
            <Pagination filter={filter} fnFetchPage={commRefFetchPage} fnPageUpdate={commRefPageUpdate} />

            <CommRefList />

            <Pagination filter={filter} fnFetchPage={commRefFetchPage} fnPageUpdate={commRefPageUpdate} />
        </>
    );
}
